import { createSlice } from '@reduxjs/toolkit'
import CommonServices from '../../services/commonServices';

const initialState = {
  intervetionTypes: []
};

const intervetionTypesSlice = createSlice({
  name: 'intervetionTypes',
  initialState,
  reducers: {
    intervetionTypesLoaded(state, action) {
      state.intervetionTypes = action.payload;
    }
  },
})

export const { intervetionTypesLoaded } = intervetionTypesSlice.actions;

export default intervetionTypesSlice.reducer;

export const fetchIntervetionTypes = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getIntervetionTypes();
    if (respData.success) {
      const intervetionTypeList = respData.responseObject.value.interventionTypes;

      if (intervetionTypeList) {
        const objectsArray = intervetionTypeList.map((item) => ({ value: item.id, label: item.description }));
        dispatch(intervetionTypesLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

